<template>
  <div>
    <form>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-4">
          <label for="imageUpload" class="custom-file-upload">
            <i class="pi pi-cloud-upload"> Personal</i>
          </label>
          <input id="imageUpload" type="file" style="margin-bottom: 2em;"
                 @change="onFileSelect"/>
        </div>
        <div class="p-field p-col-4" v-if="this.url !==null">
          <div class="product-item">
            <div class="product-item-content">
              <div class="p-mb-3">
                <img :src="this.url" style="height:100px;width:100px" class="product-image"/>
              </div>
              <div>
              </div>
            </div>
          </div>
          <div class="p-field p-col-3">
            <Button class="p-button-raised p-button-danger"
                    @click.prevent="removeImage" icon="pi pi-times" label="Remove"/>
          </div>
        </div>

      </div>

      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-4">
          <label for="imageUpload1" class="custom-file-upload">
            <i class="pi pi-cloud-upload"> Citizenship</i>
          </label>
          <input id="imageUpload1" type="file" style="margin-bottom: 2em;" @change="onCitizenshipSelect"/>
        </div>
        <div class="p-field p-col-4" v-if="this.url1 !==null">
          <div class="product-item">
            <div class="product-item-content">
              <div class="p-mb-3">
                <img :src="this.url1" style="height:100px;width:100px" class="product-image"/>
              </div>
              <div>
                <div class="p-field p-col-3">
                  <Button class="p-button-raised p-button-danger"
                          @click.prevent="removeCitizenship" label="Remove"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-4">
          <label for="imageUpload3" class="custom-file-upload">
            <i class="pi pi-cloud-upload"> CV</i>
          </label>
          <input id="imageUpload3" type="file" style="margin-bottom: 2em;" @change="onCvSelect">
        </div>
        <div class="p-field p-col-4" v-if="this.url2 !== null">
          <div class="product-item">
            <div class="product-item-content">
              <div class="p-mb-3">
                <img :src="this.url2" style="height:100px;width:100px" class="product-image"/>
              </div>
              <div>
                <div class="p-field p-col-3">
                  <Button class="p-button-raised p-button-danger"
                          @click.prevent="removeCvFile" label="Remove"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Carousel from 'primevue/carousel'
import Button from 'primevue/button'

export default {
  name: 'documentUpload',
  data() {
    return {
      url: null,
      url1: null,
      url2: null,
      personalFile: null,
      citizenshipFile: null,
      cvFile: null,
      imageList: null,
      deletedImage: []
    }
  },
  methods: {
    removeImage(event) {
      // if (data.id !== undefined && data !== null) {
      //   this.deletedImage.push(data.id)
      // }
      this.url = null
      this.personalFile = null
    },
    removeCitizenship() {
      this.url1 = null
      this.citizenshipFile = null
    },
    removeCvFile() {
      this.url2 = null
      this.cvFile = null
    },
    onFileSelect() {
      let selectedFile = event.target.files[0]
      let fileExtension = selectedFile.name.split('.').pop()
      if (fileExtension !== 'jpg' && fileExtension !== 'jpeg' && fileExtension !== 'png') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select Valid Image!', life: 3000})
        return
      }
      this.personalFile = selectedFile
      let reader = new FileReader()
      reader.onload = (e) => {
        this.url = e.target.result
      }
      reader.readAsDataURL(selectedFile)
      event.target.value = ''
    },
    onCitizenshipSelect() {
      let selectedFile = event.target.files[0]
      let fileExtension = selectedFile.name.split('.').pop()
      if (fileExtension !== 'jpg' && fileExtension !== 'jpeg' && fileExtension !== 'png') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select Valid Image!', life: 3000})
        return
      }
      this.citizenshipFile = selectedFile
      let reader = new FileReader()
      reader.onload = (e) => {
        this.url1 = e.target.result
      }
      reader.readAsDataURL(selectedFile)
      event.target.value = ''
    },
    onCvSelect() {
      let selectedFile = event.target.files[0]
      let fileExtension = selectedFile.name.split('.').pop()
      if (fileExtension !== 'jpg' && fileExtension !== 'jpeg' && fileExtension !== 'png') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select Valid Image!', life: 3000})
        return
      }
      this.cvFile = selectedFile
      let reader = new FileReader()
      reader.onload = (e) => {
        this.url2 = e.target.result
      }
      reader.readAsDataURL(selectedFile)
      event.target.value = ''
    }
  },
  components: {
    Carousel,
    Button
  }
}
</script>

<style scoped>
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  background-color: #f57224;
  color: white;
}
</style>



// WEBPACK FOOTER //
// documentUpload.vue?27ea251f